import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import styles from "./ListRoleSelect.module.css";

const cx = classNames.bind(styles);
const CheckBox = ({
  it,
  item,
  listPermission,
  role,
  setRole,
  checkAll,
  change
}) => {
  const [isChange, setIsChange] = useState(false);
  const [isCheck, setIsCheck] = useState();
  const handleCheckRole = (e, permission, typePermission) => {
    setIsCheck(e.target.checked);
    setIsChange(true);
    if (e.target.checked) {
      setRole([
        ...role,
        {
          PERMISSION_TYPE_CODE: typePermission.CODE,
          USER_FUNCTION_CODE: permission.CODE,
          NOTE: permission.SUBJECT_NAME + ", " + typePermission.SUBJECT_NAME,
        },
      ]);
    } else {

      const data = role.filter(
        (item) =>
          item.PERMISSION_TYPE_CODE !== typePermission.CODE ||
          item.USER_FUNCTION_CODE !== permission.CODE
      );
      setRole(data);
    }
  };
  useEffect(() => {
    if (change) {
      setIsChange(true)
      setIsCheck(checkAll)
    }
  }, [checkAll, change])
  const check = (userType, userFunction) => {
    const data = listPermission?.data?.some(
      (item) =>
        item.PERMISSION_TYPE_CODE === userType.CODE &&
        item.USER_FUNCTION_CODE === userFunction.CODE
    );
    return data;
  };
  return (
    <div className={cx("children-item")}>
      <input
        onChange={(e) => handleCheckRole(e, item, it)}
        checked={isChange ? isCheck : check(it, item)}
        type="checkbox"
      />
      <span>{it.SUBJECT_NAME}</span>
    </div>
  );
};

export default CheckBox;
